import React, { createContext, useContext, useState } from 'react';

// ─── Contexte de langue ──────────────────────────────────────────────────────
const LanguageContext = createContext({ lang: 'fr', setLang: () => {} });

// ─── Détection initiale (URL > localStorage > navigator) ─────────────────────
function detectLanguage() {
  // 1. Paramètre URL ?lang= — prioritaire (permet l'indexation Google)
  const params = new URLSearchParams(window.location.search);
  const paramLang = params.get('lang');
  if (paramLang === 'fr' || paramLang === 'en') return paramLang;

  // 2. Préférence mémorisée (localStorage)
  const saved = localStorage.getItem('pb-lang');
  if (saved === 'fr' || saved === 'en') return saved;

  // 3. Détection automatique du navigateur
  return navigator.language.startsWith('fr') ? 'fr' : 'en';
}

// ─── Provider ────────────────────────────────────────────────────────────────
export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectLanguage);

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem('pb-lang', l);

    // Mise à jour de l'URL sans rechargement de page
    const url = new URL(window.location.href);
    url.searchParams.set('lang', l);
    window.history.replaceState({}, '', url.toString());
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

// ─── Hook ────────────────────────────────────────────────────────────────────
export function useLanguage() {
  return useContext(LanguageContext);
}
